/*
公共方法
 */
export function getContactTel(){
    // return '15338170138'
    return ''
}

export function backTop(){
    // document.getElementById('wrap').scrollTop = 0
    // let that = this
    let timer = setInterval(function(){
        let osTop = document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 2);
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
        // let osTop = that.$refs.wrap.scrollTop
    // that.$nextTick(() => {
    //     // that.$refs.wrap.scrollTop = 0
    //     that.$refs.wrap.scrollTo({
    //         top: 0,
    //         behavior: 'smooth',
    //     });
    // })
        if(osTop === 0){
            clearInterval(timer);
        }
    },30)
}

export function formatTime(timeStr, type){
    var tsplist = timeStr.split('T')
    var dates = tsplist[0]
    var times = tsplist[1]
    var year = dates.split('-')[0]
    var month = dates.split('-')[1]
    var day = dates.split('-')[2]
    var hour = times.split(':')[0]
    var min = times.split(':')[1]
    //console.log(year)
    if(type === 1)
        return month + '-' + day + ' ' + hour + ':' + min
    return year + '-' + month + '-' + day + ' ' + hour + ':' + min
}

export function formatSeconds(seconds, dateFormat = 'H:i:s') {
    if(seconds<=0){
        return '00:00:00'
    }
    else {
        var obj = {}
        obj.H = Number.parseInt(seconds / 3600)
        obj.i = Number.parseInt((seconds - obj.H * 3600) / 60)
        obj.s = Number.parseInt(seconds - obj.H * 3600 - obj.i * 60)
        if (obj.H < 10) {
            obj.H = '0' + obj.H
        }
        if (obj.i < 10) {
            obj.i = '0' + obj.i
        }
        if (obj.s < 10) {
            obj.s = '0' + obj.s
        }
        // 3.解析
        return dateFormat.replace('H', obj.H).replace('i', obj.i).replace('s', obj.s)
    }
}
